import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

const filter = {
	VozidloId: null as number | null,
	NvSkladId: null as number | null,
	VyrazenPrp: null as number | null,
	VyrobekvozOzn: null as string | null,
	KaroserieNr: null as string | null,
	Spz: null as string | null,
	BarvaText: null as string | null,
	BarvaKod: null as number | null,
	ModelRok: null as number | null,
	ModelKod: null as string | null,
	MotorNr: null as string | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
